import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { useContext, useEffect, useMemo } from 'react';
import { EditorContext } from '../../Context';
import { TextAreaCommandOrchestrator } from '../../commands';
import handleKeyDown from './handleKeyDown';
import shortcuts from './shortcuts';
import "./index.css";
export default function Textarea(props) {
  var prefixCls = props.prefixCls,
    other = _objectWithoutProperties(props, ["prefixCls"]);
  var _useContext = useContext(EditorContext),
    markdown = _useContext.markdown,
    commands = _useContext.commands,
    commandOrchestrator = _useContext.commandOrchestrator,
    tabSize = _useContext.tabSize,
    _onChange = _useContext.onChange,
    dispatch = _useContext.dispatch;
  var textRef = /*#__PURE__*/React.createRef();
  var executeRef = React.useRef();
  useEffect(function () {
    if (textRef.current && dispatch) {
      var _commandOrchestrator = new TextAreaCommandOrchestrator(textRef.current);
      executeRef.current = _commandOrchestrator;
      dispatch({
        textarea: textRef.current,
        commandOrchestrator: _commandOrchestrator
      });
    }
  }, []);
  return useMemo(function () {
    return /*#__PURE__*/React.createElement("textarea", _extends({}, other, {
      ref: textRef,
      className: "".concat(prefixCls, "-text-input"),
      value: markdown,
      onScroll: props.onScroll,
      onKeyDown: function onKeyDown(e) {
        handleKeyDown(e, tabSize);
        shortcuts(e, commands, executeRef.current);
      },
      onChange: function onChange(e) {
        dispatch && dispatch({
          markdown: e.target.value
        });
        _onChange && _onChange(e.target.value);
      }
    }));
  }, [markdown]);
}